<template>
  <a
    href="#"
    @click.prevent="$emit('tab-click', slug)"
    class="ps-flex ps-items-center ps-justify-center ps-no-underline"
  >
    <slot />
    <slot name="after" />
  </a>
</template>

<script>
export default {
  name: 'BaseTab',
  props: {
    slug: String,
    label: String
  }
}
</script>
